/* eslint-disable promise/param-names */
import { SEARCH_REQUEST, SEARCH_ERROR, SEARCH_SUCCESS, SEARCH_LOGOUT } from '../actions/search'
import axios from 'axios'
import qs from 'qs'


const state = { searchResults: [], searching: false}

const getters = {
  getSearchResults: state => state.searchResults,
  getSearching: state => state.searching,
}


/*
import apiCall from '@/utils/api'

const actions = {
  [SEARCH_REQUEST]: ({commit, dispatch}) => {
    commit(SEARCH_REQUEST)
    apiCall({url: 'search/all'})
      .then(resp => {
        console.log('Search success')
        commit(SEARCH_SUCCESS, resp)
      })
      .catch(resp => {
        commit(SEARCH_ERROR)
        // if resp is unauthorized, logout, to
        //dispatch(AUTH_LOGOUT)
        console.log('Logout');
      })
  },
}
*/



const actions = {
  [SEARCH_REQUEST]: ({commit, dispatch}, searchTerm) => {
    return new Promise((resolve, reject) => {

      console.log("Sending search with term " + searchTerm);
      commit(SEARCH_REQUEST)

      const data = searchTerm;

      const headers = {
        'Content-Type': 'application/json'
      };
      axios({url: '/members/io/search', data, headers, method: 'POST'})
      .then(resp => {
        commit(SEARCH_SUCCESS, resp.data)
        //resolve(resp)
      })
      .catch(err => {
        console.log("SearchRequest: error");
        commit(SEARCH_ERROR, err)
        reject(err)
      })
    })
  },
  [SEARCH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(SEARCH_LOGOUT)
      resolve()
    })
  }
}


const mutations = {
  [SEARCH_REQUEST]: (state) => {
    state.status = 'loading'
    state.searching = true
  },
  [SEARCH_SUCCESS]: (state, res) => {
    state.status = 'success'
    state.searchResults = res.searchResults
    state.searching = false
    //state.searchResults = [{'fileName' : 'Test1_' + Math.floor(Math.random() * 10) + '.pdf'}, {'fileName' : 'Test2_' + Math.floor(Math.random() * 10) + '.pdf'}]
  },
  [SEARCH_ERROR]: (state) => {
    state.status = 'error'
    state.searching = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
